import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'

export const logoutApi = createApi({
  reducerPath: 'logoutApi',
  baseQuery,
  endpoints: (builder) => ({
    logout: builder.mutation<
      void,
      void
    >({
      query: () => ({
        url: '/auth/logout',
        method: 'post',
      }),
    }),
  }),
})

export const {
  useLogoutMutation
} = logoutApi
